import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active p-4",
  id: "tab-basico",
  role: "tabpanel",
  "aria-labelledby": "home-tab",
  tabindex: "0"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-md-9" }
const _hoisted_18 = { class: "row mb-2" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = { class: "col-md-9" }
const _hoisted_22 = {
  class: "tab-pane fade",
  id: "tab-termos-uso",
  role: "tabpanel",
  "aria-labelledby": "profile-tab",
  tabindex: "0"
}
const _hoisted_23 = {
  class: "tab-pane fade",
  id: "tab-politica-privacidade",
  role: "tabpanel",
  "aria-labelledby": "contact-tab",
  tabindex: "0"
}
const _hoisted_24 = {
  class: "tab-pane fade",
  id: "tab-contrato-empresa",
  role: "tabpanel",
  "aria-labelledby": "disabled-tab",
  tabindex: "0"
}
const _hoisted_25 = {
  class: "tab-pane fade",
  id: "tab-contrato-parceiro",
  role: "tabpanel",
  "aria-labelledby": "disabled-tab",
  tabindex: "0"
}
const _hoisted_26 = { class: "card-footer" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-2" }
const _hoisted_29 = { class: "col-md-8" }
const _hoisted_30 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_31 = {
  key: 1,
  class: "fw-bold text-danger"
}
const _hoisted_32 = { class: "col-md-2" }

import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/paramsService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
 import Assinatura from "@/components/Assinatura/Index.vue";
import UploadFoto from "@/components/UploadFoto/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import Editor from '@tinymce/tinymce-vue'
import { urlImagem } from "@/services/usuariosService";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Cadastro',
  setup(__props) {


//vue
const route = useRoute();

  var controle = reactive({

    model: {
      paramId: 0,
      nomeEmpresa: '',
      path: null,
      urlApi: null,
      contratoParceiro: null,
      contratoEmpresa: null,
      politicaPrivacidade: null,
      termosDeUso: null,
      chaveValor: null,
      assinaturaContratada: null,
      fundoCartao: null,
      diaVencimentoBoleto: 10,
      dataCadastro: null,
      usuCadastroId: null,
      dataAlteracao: null,
      usuAlteracaoId: null,
      dataExclusao: null,
      usuExclusaoId: null,
      modelState: { isValid: true, erros: [] }
    } as service.Param,
    frenteCartao: null as File | null,
    fundoCartao: null as File | null,
    tipos: [] as { texto: string; valor: number }[],
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],

      erro: "",
      status: ""
  })

  onMounted(() => {
    console.log("buscar")
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then(r => {
          controle.model = r;
        })
        .catch(error => {
          controle.erro = `Erro ao carregar : ${error}`;
        });
    }


  });

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)
      
      // 4. Fazer upload das fotos se existirem
      if (controle.frenteCartao?.size > 0) {

          const arquivo = controle.frenteCartao as File
          try {
            controle.status = "Salvando foto...";
            console.log(`Salvando foto...`)
            const urlImagem = await service.uploadFrenteCartao(resultado.paramId, arquivo)
            console.log(`Salvando foto concluído:`, urlImagem)
            
          } catch (uploadError) {
            controle.erro = `Erro ao salvar foto: ${uploadError}...`;
          }

      }

       // 4. Fazer upload das fotos se existirem
      if (controle.fundoCartao?.size > 0) {

          const arquivo = controle.fundoCartao as File
          try {
            controle.status = "Salvando foto...";
            console.log(`Salvando foto...`)
            const urlImagem = await service.uploadFundoCartao(resultado.paramId, arquivo)
            console.log(`Salvando foto concluído:`, urlImagem)
            
          } catch (uploadError) {
            controle.erro = `Erro ao salvar foto: ${uploadError}...`;
          }

      }
      
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
  }

  async function salvarAssinatura(valor: string) {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await service.SalvarAssinaturaBase64({ paramId: controle.model.paramId, arquivoBase64: valor })

      if (resultado) {
        controle.status = "Assinatura salva com sucesso!";
      }

    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
  }




return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Parâmetros",
      items: [ 
    { label: 'Parâmetros', to: '/parametros' }, 
    { label: 'Cadastro', to: '/parametros/cadastro' } ]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro='')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[27] || (_cache[27] = _createElementVNode("ul", {
              class: "nav nav-tabs",
              id: "myTab",
              role: "tablist"
            }, [
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link active",
                  id: "tab1",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#tab-basico",
                  type: "button",
                  role: "tab",
                  "aria-controls": "home-tab-pane",
                  "aria-selected": "true"
                }, "Básico")
              ]),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "tab2",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#tab-termos-uso",
                  type: "button",
                  role: "tab",
                  "aria-controls": "profile-tab-pane",
                  "aria-selected": "false"
                }, "Termos de Uso")
              ]),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "tab3",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#tab-politica-privacidade",
                  type: "button",
                  role: "tab",
                  "aria-controls": "contact-tab-pane",
                  "aria-selected": "false"
                }, "Política de privacidade")
              ]),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "tab4",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#tab-contrato-empresa",
                  type: "button",
                  role: "tab",
                  "aria-controls": "disabled-tab-pane",
                  "aria-selected": "false"
                }, "Contrato Empresa")
              ]),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "tab5",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#tab-contrato-parceiro",
                  type: "button",
                  role: "tab",
                  "aria-controls": "disabled-tab-pane",
                  "aria-selected": "false"
                }, "Contrato Parceiro")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "paramId",
                          class: "form-label"
                        }, "ID")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.paramId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.paramId) = $event)),
                          id: "paramId",
                          formato: 'Numero'
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "nomeEmpresa",
                          class: "form-label obrigatorio"
                        }, "Nome")
                      ], -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.nomeEmpresa,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.nomeEmpresa) = $event)),
                          id: "nomeEmpresa"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "urlApi",
                          class: "form-label obrigatorio"
                        }, "Url Api")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.urlApi,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.urlApi) = $event)),
                          id: "urlApi"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "diaVencimentoBoleto",
                          class: "form-label"
                        }, "Dia Vencimento Boleto")
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.diaVencimentoBoleto,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.diaVencimentoBoleto) = $event)),
                          id: "diaVencimentoBoleto",
                          formato: 'Numero',
                          class: "text-end"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "assinatura",
                          class: "form-label"
                        }, "Assinatura")
                      ], -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(Assinatura, {
                          modelValue: _unref(controle).model.assinaturaContratada,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.assinaturaContratada) = $event)),
                          urlImagem: `${_unref(config).urlApi}/Param/assinatura${_unref(controle).model.paramId}.png?${Date.now()}`,
                          onSalvar: salvarAssinatura
                        }, null, 8, ["modelValue", "urlImagem"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "foto",
                          class: "form-label"
                        }, "Frente do cartão")
                      ], -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createTextVNode(_toDisplayString(`${_unref(config).urlApi}/Cartao/frente.png`) + " ", 1),
                        _createVNode(UploadFoto, {
                          modelValue: _unref(controle).frenteCartao,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).frenteCartao) = $event)),
                          id: "foto",
                          accept: 'image/*',
                          alt: 'Frente do cartão',
                          imageUrl: `${_unref(config).urlApi}/Cartao/frente.png`
                        }, null, 8, ["modelValue", "imageUrl"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "foto",
                          class: "form-label"
                        }, "Fundo do cartão")
                      ], -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _createTextVNode(_toDisplayString(`${_unref(config).urlApi}/Cartao/fundo.png`) + " ", 1),
                        _createVNode(UploadFoto, {
                          modelValue: _unref(controle).fundoCartao,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(controle).fundoCartao) = $event)),
                          id: "foto",
                          accept: 'image/*',
                          alt: 'Fundo do cartão',
                          imageUrl: `${_unref(config).urlApi}/Cartao/fundo.png`
                        }, null, 8, ["modelValue", "imageUrl"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(Editor), {
                  "api-key": "lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7",
                  init: {
                    height: 700,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | removeformat | help'
                  },
                  modelValue: _unref(controle).model.termosDeUso,
                  "onUpdate:modelValue": [
                    _cache[9] || (_cache[9] = ($event: any) => ((_unref(controle).model.termosDeUso) = $event)),
                    _cache[10] || (_cache[10] = (value) => _unref(controle).model.termosDeUso = value)
                  ]
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(Editor), {
                  "api-key": "lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7",
                  init: {
                    height: 700,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | removeformat | help'
                  },
                  modelValue: _unref(controle).model.politicaPrivacidade,
                  "onUpdate:modelValue": [
                    _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).model.politicaPrivacidade) = $event)),
                    _cache[12] || (_cache[12] = (value) => _unref(controle).model.politicaPrivacidade = value)
                  ]
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col-md-12 mb-2" }, [
                    _createElementVNode("strong", null, "Variáveis para contrato empresa:")
                  ])
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "col-md-12 mb-2" }, " Campos aceitos [NOMEEMPRESA], [RESPONSAVELEMPRESA], [DOCEMPRESA], [CONTRATANTE], [CONTRATADA], [DIA], [MES], [ANO], ")
                ], -1)),
                _createVNode(_unref(Editor), {
                  "api-key": "lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7",
                  init: {
                    height: 700,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | removeformat | help'
                  },
                  modelValue: _unref(controle).model.contratoEmpresa,
                  "onUpdate:modelValue": [
                    _cache[13] || (_cache[13] = ($event: any) => ((_unref(controle).model.contratoEmpresa) = $event)),
                    _cache[14] || (_cache[14] = (value) => _unref(controle).model.contratoEmpresa = value)
                  ]
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_unref(Editor), {
                  "api-key": "lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7",
                  init: {
                    height: 700,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | removeformat | help'
                  },
                  modelValue: _unref(controle).model.contratoParceiro,
                  "onUpdate:modelValue": [
                    _cache[15] || (_cache[15] = ($event: any) => ((_unref(controle).model.contratoParceiro) = $event)),
                    _cache[16] || (_cache[16] = (value) => _unref(controle).model.contratoParceiro = value)
                  ]
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (salvar()))
                }, "Salvar")
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_unref(controle).erro == null && _unref(controle).status != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(controle).status), 1))
                  : _createCommentVNode("", true),
                (_unref(controle).erro != null )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(controle).erro), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_RouterLink, {
                  class: "btn btn-sm btn-secondary float-end",
                  to: '/parametros'
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode("Fechar", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})